import { FC, useCallback, useEffect, useRef, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import BodyScrollLock from '../BodyScrollLock/BodyScrollLock'
import { useKeyDown } from '../../hooks/KeyDown/KeyDown'
import { useOutsideClick } from '../../hooks/OutsideClick/OutsideClick'
import * as S from './announcement.styles'

const STORAGE_KEY = 'uncle_ve_announce_lootsi_8_dismissed'

const Announcement: FC = () => {
    const { t } = useTranslation()
    const [isVisible, setIsVisible] = useState(false)
    const panelRef = useRef<HTMLDivElement>(null)

    useEffect(() => {
        try {
            setIsVisible(localStorage.getItem(STORAGE_KEY) !== 'true')
        } catch {
            setIsVisible(true)
        }
    }, [])

    const dismiss = useCallback(() => {
        setIsVisible(false)
        try {
            localStorage.setItem(STORAGE_KEY, 'true')
        } catch {
            // ignore storage errors
        }
    }, [])

    const handleKeyDown = useCallback((event: { key: string }) => {
        if (event.key === 'Escape') {
            dismiss()
        }
    }, [dismiss])

    useKeyDown(handleKeyDown)

    useOutsideClick(panelRef, (trigger) => {
        if (!trigger) {
            dismiss()
        }
    })

    if (!isVisible) {
        return null
    }

    return (
        <S.Overlay role="presentation">
            <BodyScrollLock />
            <S.Panel
                ref={panelRef}
                role="dialog"
                aria-modal="true"
                aria-labelledby="address-announcement"
            >
                <S.CloseButton
                    type="button"
                    onClick={dismiss}
                    aria-label={t('close', { defaultValue: 'Close' })}
                >
                    ×
                </S.CloseButton>
                <S.Text id="address-announcement">
                    <Trans
                        i18nKey="announce"
                        values={{
                            middleOldAddress: t('middle_old_contacts_address'),
                            contactsAddress: t('contacts_address'),
                        }}
                        components={{
                            oldAddress: <S.HighlightAddress />,
                            newAddress: <S.HighlightAddress />,
                        }}
                    />
                </S.Text>
            </S.Panel>
        </S.Overlay>
    )
}

export default Announcement
